import { validateAcceptableSpecialCharacters, validateURL, validateName, validateEmailAddress } from '../../../../../../helpers/genericHelpers';

const dateValidator = ( values ) => {
    const errors = {};

    const start_month = +values.start_month,
        start_year = +values.start_year,
            end_month = +values.end_month,
                end_year = +values.end_year;

    // if ( !values.start_month && !values.start_year ) {
    // errors.start_year = 'Start date is required.';
    // }

    if ( values.start_month && !values.start_month.value ) {
        errors.start_month = 'is required';
    }

    if ( values.start_year && !values.start_year.value ) {
        errors.start_year = 'is required';
    }

    if ( !values.end_month  ) {
        errors.end_month = 'is required';
    }

    if ( !values.end_year ) {
        errors.end_year = 'is required';
    }

    if (!( values.i_still_work_here || values.i_still_study_here )) {
        if ( (values.end_month && !values.end_month.value) || (values.end_year && !values.end_year.value)) {
            errors.end_month = 'is required';
            errors.end_year = 'is required';
        } else {
            const startDate = new Date(start_year, start_month - 1);
            const endDate = new Date(end_year, end_month - 1);
            const now = new Date();
            if (endDate < startDate) {
                errors.end_year = 'End date is before start date.'
            } else if (endDate > now) {
                errors.end_year = 'End date is in the future.'
            }
        }
    }
  return errors;
};

export const experience = (values) => {
    const errors = {};

    if (!values.title) {
        errors.title = ' is required'
    }
    if (!values.company) {
        errors.company = ' is required'
    }


    if ((values.title) && (validateAcceptableSpecialCharacters(values.title))) {
        errors.title = " must be A-Z, a-z, 0-9, '-/&., ";
    }

    if ((values.title && values.title.length > 60) ) {
        errors.title = " must be 60 characters or less";
    }

    if ((values.location) && (validateAcceptableSpecialCharacters(values.location))) {
        errors.location = " must be A-Z, a-z, 0-9, '-/&., ";
    }

    errors.start_month = (values.start_month) ? dateValidator(values).start_month : ' isRequired';
    errors.end_month = dateValidator(values).end_month;
    errors.start_year = dateValidator(values).start_year;
    errors.end_year = dateValidator(values).end_year;
    if (errors.title || errors.company || errors.start_month || errors.start_year) {
        errors.errors_on_form = "Error: All mandatory fields need to be complete. Please check and save again."
    }
    return errors;
};

export const certificates = (values) => {
    const errors = {};
    const regexLicense = /^[0-9a-zA-Z\s \(\)\-\\\/\.]+$/;

    if ((values.name) && (validateAcceptableSpecialCharacters(values.name))) {
        errors.name = " must be A-Z, a-z, 0-9, ‘''_\/.()-,& ";
    }

    if ((values.authority) && (validateAcceptableSpecialCharacters(values.authority))) {
        errors.authority = " must be A-Z, a-z, 0-9, ‘''_\/.()-,& ";
    }

    if ((values.license_number) && !(regexLicense.test(values.license_number))) {
        errors.license_number = " must be A-Z, a-z, 0-9, ()-\/@.";
    }

    if ((values.url) && (validateURL(values.url))) {
        errors.url = " must begin with http:// or https://";
    }

    errors.start_month = dateValidator(values).start_month;
    errors.end_month = dateValidator(values).end_month;
    errors.start_year = dateValidator(values).start_year;
    errors.end_year = dateValidator(values).end_year;

    if (errors.name || errors.start_year) {
        errors.errors_on_form = "Error: All mandatory fields need to be complete and valid. Please check and save again."
    }
        return errors;
    };

export const education = (values) => {
    const errors = {};

    if (!values.institution) {
        errors.institution = ' is required'
    }
    if (!values.qualification) {
        errors.qualification = ' is required'
    }
    if ((values.institution) && (validateAcceptableSpecialCharacters(values.institution))) {
        errors.institution = " must be A-Z, a-z, 0-9, ‘''_\/.()-,& ";
    }
    if ((values.qualification) && (validateAcceptableSpecialCharacters(values.qualification))) {
        errors.qualification = " must be A-Z, a-z, 0-9, ‘''_\/.()-,& ";
    }

    errors.end_month = dateValidator(values).end_month;
    errors.end_year = dateValidator(values).end_year;

    if (errors.institution || errors.qualification) {
        errors.errors_on_form = "Error: All mandatory fields need to be complete and valid. Please check and save again."
    }
    return errors;
};

export const requestEndorsement = values => {
    const errors = {};

    if (!values.first_name) {
        errors.first_name = ' is required'
    } else if(validateName(values.first_name)) {
        errors.first_name = " must only contain \"A-Z and -\")";
    }

    if (!values.last_name) {
        errors.last_name = ' is required'
    } else if(validateName(values.last_name)) {
        errors.last_name = " must only contain (\"A-Z and -\")";
    }

    if(!values.email_address) {
        errors.email_address = ' is required'
    } else if(validateEmailAddress(values.email_address)) {
        errors.email_address = " must be valid";
    }
    return errors;
};

 export const general = values => {
    const errors = {};

    if (!values.title) {
        errors.title = ' is required'
    }

    if (!values.name) {
        errors.name = ' is required'
    }

    if (!values.first_name) {
        errors.first_name = ' is required'
    }

    if (!values.last_name) {
        errors.last_name = ' is required'
    }

    if (!values.email_address) {
        errors.email_address = ' is required'
    }

    if (values.month && !values.month.value) {
        errors.month = ' is required'
    }

    if (values.year && !values.year.value) {
        errors.year = ' is required'
    }

    return errors;
};

export const location = values => {
  return {
    country: !values.country && 'Country is required',
    region: !values.region && 'Region is required'
  };
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/syncValidator.js